import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";

import { VAVE, TESTINGAPPROVE } from "../../AppConstant";

function AlertDialogForm({ request, setRefreshApi }) {
  const [inputValue, setInputValue] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [testingRequired, setTestingRequired] = useState("");

  const handleCloseAlert = () => setOpenAlert(false);

  const currentEmpId = localStorage.getItem("empid");
  const handleSubmit = async (status) => {
    // Validate first
    if (inputValue.trim() === "") {
      setOpenAlert(true);
      return;
    }

    if (testingRequired.trim() === "") {
      setOpenAlert(true);
      return;
    }
    setRefreshApi(true);
    const formData = new FormData();

    formData.append("testing_comment", inputValue);
    formData.append("testing_status", status);
    formData.append("is_testing_completed", testingRequired);
    formData.append("approved_by", localStorage.getItem("empid"));
    formData.append("ideadata_id", request?.id_x ?? "");

    try {
      setIsLoading(true);
      await axios.post(VAVE + TESTINGAPPROVE, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Submitted successfully!");
      // Optionally clear state or notify parent here
      setInputValue("");
      setRefreshApi(true);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setOpenAlert(false);
      setRefreshApi(true);

      setIsLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      <label
        htmlFor="matrix"
        style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
      >
        Testing Completed*
      </label>

      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <label>
          <input
            type="radio"
            name="matrix"
            value="yes"
            onChange={() => setTestingRequired("yes")}
          />{" "}
          Yes
        </label>
        <label>
          <input
            type="radio"
            name="matrix"
            value="no"
            onChange={() => setTestingRequired("no")}
          />{" "}
          No
        </label>
      </div>
      <label
        htmlFor="comment"
        style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
      >
        Comment*
      </label>

      <TextField
        id="comment"
        placeholder="Enter comment"
        fullWidth
        required
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        size="small"
      />

      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleSubmit("accepted")}
          style={{ marginRight: "10px" }}
          disabled={isLoading}
        >
          Accept
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={() => handleSubmit("rejected")}
          disabled={isLoading}
        >
          Reject
        </Button>
      </div>

      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Missing Required Field</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter a comment before accepting or rejecting. This field is
            mandatory.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialogForm;
